export const disabledServicesUrl = {
    de: 'beratung/tipps-produkt-selbst-installieren.html',
    en: 'advice/tips-product-self-installation.html',
    fr: 'conseils/astuces-pour-installer-vous-meme-des-produits.html',
    nl: 'advies/tips-product-zelf-installeren.html',
};
//# sourceMappingURL=types.js.map